import script from "./InvoicePdfDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvoicePdfDialog.vue?vue&type=script&setup=true&lang=ts"

import "./InvoicePdfDialog.vue?vue&type=style&index=0&id=49b970ab&lang=less"

const __exports__ = script;

export default __exports__